import type { CardConflictGroup } from "@common/utils/redline/text/card-collisions";
import type { RedlineTextProposal } from "@common/utils/redline/wire/redline-payload";

import type { ProposalCardContent } from "../proposal-card/card-content";
import type { ChangeThroughoutCardSelection } from "../proposal-card/change-throughout-selections";

export interface TrackerCard {
  actionId: string;
  cardNumber: number;
  isApplied: boolean;
  supersededBy: string | null;
  textRedlineBeforeEdit: RedlineTextProposal | null;
  textRedlineWhenOpened: RedlineTextProposal | null;
  textBeforeEdit: string | null;
  content: ProposalCardContent;
  changeThroughoutSelection: ChangeThroughoutCardSelection | null;
  ridesWithCardId?: string;
}

export interface TrackerConflictGroup {
  group: CardConflictGroup;
  cards: TrackerCard[];
}

export type TrackerRowState = "pending" | "applied" | "dismissed";

export type ZoneDecision =
  | { kind: "card"; cardId: string }
  | { kind: "original" }
  | { kind: "custom"; text: string };

export function textRedlineOfTrackerCard(card: TrackerCard): RedlineTextProposal | null {
  return card.content.kind === "redline" || card.content.kind === "table" || card.content.kind === "paragraph" ? card.content.textRedline : null;
}

export function trackerCardHasUserEdit(card: TrackerCard): boolean {
  return card.textRedlineBeforeEdit !== null || card.textBeforeEdit !== null;
}
